export const uploadControllerActionTypes = {
	UPLOAD_CONTROLLER_POST_URL_REQUEST: 'UPLOAD_CONTROLLER_POST_URL_REQUEST',
	UPLOAD_CONTROLLER_POST_URL_SUCCESS: 'UPLOAD_CONTROLLER_POST_URL_SUCCESS',
    UPLOAD_CONTROLLER_POST_URL_FAILURE: 'UPLOAD_CONTROLLER_POST_URL_FAILURE',
    
    UPLOAD_CONTROLLER_FILE_REQUEST: 'UPLOAD_CONTROLLER_FILE_REQUEST',
    UPLOAD_CONTROLLER_FILE_SUCCESS: 'UPLOAD_CONTROLLER_FILE_SUCCESS',
    UPLOAD_CONTROLLER_FILE_FAILURE: 'UPLOAD_CONTROLLER_FILE_FAILURE',
    UPLOAD_CONTROLLER_FILE_COMPLETE: 'UPLOAD_CONTROLLER_FILE_COMPLETE', //TODO: Do we need this?

    UPLOAD_CONTROLLER_FILE_PROGRESS: 'UPLOAD_CONTROLLER_FILE_PROGRESS',
    UPLOAD_CONTROLLER_FILE_STARTED: 'UPLOAD_CONTROLLER_FILE_STARTED',

    UPLOAD_CONTROLLER_ENQUEUE_ITEM: 'UPLOAD_CONTROLLER_ENQUEUE_ITEM',
    UPLOAD_CONTROLLER_DEQUEUE_ITEM: 'UPLOAD_CONTROLLER_DEQUEUE_ITEM',

    UPLOAD_CONTROLLER_ADD_FILE: 'UPLOAD_CONTROLLER_ADD_FILE',
    UPLOAD_CONTROLLER_ADD_FILES: 'UPLOAD_CONTROLLER_ADD_FILES',
    UPLOAD_CONTROLLER_ADD_FILE_SUCCESS: 'UPLOAD_CONTROLLER_ADD_FILE_SUCCESS',
    UPLOAD_CONTROLLER_ADD_FILES_SUCCESS: 'UPLOAD_CONTROLLER_ADD_FILE_SUCCESS',
    UPLOAD_CONTROLLER_ADD_FILES_FAILURE: 'UPLOAD_CONTROLLER_ADD_FILE_FAILURE',


    UPLOAD_CONTROLLER_CLEAR_ITEMS: 'UPLOAD_CONTROLLER_CLEAR_ITEMS',

    UPLOAD_CONTROLLER_CURRENT_COMPLETE: 'UPLOAD_CONTROLLER_CURRENT_COMPLETE',
    UPLOAD_CONTROLLER_ALL_FILES_UPLOADED: 'UPLOAD_CONTROLLER_ALL_FILES_UPLOADED',
    UPLOAD_CONTROLLER_ALL_FILES_UPLOADED_CLEAR: 'UPLOAD_CONTROLLER_ALL_FILES_UPLOADED_CLEAR',

    UPLOAD_CONTROLLER_CLEAR_UPLOADS: 'UPLOAD_CONTROLLER_CLEAR_UPLOADS',

UPLOAD_CONTROLLER_CLEAR_UPLOADS_LIST: 'UPLOAD_CONTROLLER_CLEAR_UPLOADS_LIST',

    UPLOAD_CONTROLLER_SET_CURRENT_ALBUM: 'UPLOAD_CONTROLLER_SET_CURRENT_ALBUM',

    UPLOAD_CONTROLLER_PAUSE: 'UPLOAD_CONTROLLER_PAUSE',
    UPLOAD_CONTROLLER_CONTINUE: 'UPLOAD_CONTROLLER_CONTINUE',
    UPLOAD_CONTROLLER_ALBUM_SELECT_LIST: 'UPLOAD_CONTROLLER_ALBUM_SELECT_LIST',
    UPLOAD_CONTROLLER_ALBUM_SELECT_LIST_FETCHING: 'UPLOAD_CONTROLLER_ALBUM_SELECT_LIST_FETCHING',
    UPLOAD_CONTROLLER_ALBUM_SELECT_LIST_FETCH_FAILED: 'UPLOAD_CONTROLLER_ALBUM_SELECT_LIST_FETCH_FAILED',
    UPLOAD_CONTROLLER_UPLOAD_STOPPED: 'UPLOAD_CONTROLLER_UPLOAD_STOPPED',
};



// WEBPACK FOOTER //
// ./src/uploadController/actions/uploadController-action-types.js